module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dailyReport')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _vm._v(" "), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'de2': _vm.isDe, 'it2': _vm.isIt || _vm.isFr, 'po2': _vm.isPo, 'es2': _vm.isEs, 'du2': _vm.isDu || _vm.isCz, 'sw2': _vm.isSw
    }
  }, [_c('div', {
    staticClass: "legend",
    class: {
      'it3': _vm.isIt
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/Alert.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'it4': _vm.isIt
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/target.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    class: {
      'it5': _vm.isIt
    }
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/hypo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe15"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe16"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/calib.png")
    }
  }), _c('span', {
    staticClass: "span1",
    class: {
      'span1': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe17"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/transmitter.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh3': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/basal.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh4': !_vm.isEn, 'du3': _vm.isDu
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/temp basal.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe12",
    class: {
      'de5': _vm.isDe
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/normal bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh5': !_vm.isEn, 'de4': _vm.isDe
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/extend bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/auto suspend.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/warm up.png")
    }
  }), _c('span', {
    class: {
      'span1': !_vm.isEn
    }
  }, [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh2': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/patch Deactivated.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh18': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/Auto Suspend 2.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe9",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/new Patch.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/exercise.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe10",
    class: {
      'zh9': !_vm.isEn, 'es3': _vm.isEs
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/carbs.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend",
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/calibrate_1.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/早餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/中餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/晚餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/零食.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/运动[30059].png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/icon_histogram.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe11"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/auto_bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('statics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table",
    class: {
      'de3': _vm.isDe
    }
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "padding-bottom": "5px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('events')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SG1')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Avg')) + _vm._s(_vm.unit) + _vm._s(_vm.$t('±SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_avg_dev))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_avg_dev))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('totalDose')) + " " + _vm._s(_vm.$t('ins_unit')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.total))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('carbs')) + " (g)")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.carb_total))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_min))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_min))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('bolus')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('ofMeal')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')) + _vm._s(_vm.unit))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_max))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('basal')) + " " + _vm._s(_vm.$t('ins_unit')) + "/%")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('avgSD1')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.meal_avg_sd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('target')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_np))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_np))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('foodBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.carb_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('totalExerTime')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('low1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_lp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_lp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('calibBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.corr_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('exerNum')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('high1')) + " (%)")]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hp))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hp))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('Food+coor')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.foodCoor))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('avgInten')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.events.exercise_avg_time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofRead')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_data_num))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('normalBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.normal_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofHypo')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_hypo_rds_time))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_hypo_num) + "/" + _vm._s(_vm.glucose.sg_hypo_duration))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('extendBolus')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.extent_bolus))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('ofAlert')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.bg_alarm_cnt))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.glucose.sg_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('tampBasal')) + " " + _vm._s(_vm.$t('ins_unit')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.temp_basal))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td1"
  }), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('durationStop')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.insulin.suspend_time))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _c('td', {
    staticClass: "td3"
  }), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('ofPumpAlert')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.insulin.pump_alarm_cnt))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }), _c('td')])]), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('table', {
    staticClass: "statics-table auto_mode",
    class: {
      'de3': _vm.isDe
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td2",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1222_Auto_Mode')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Avg_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucose_unit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('t1222_Below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " td3"
  }, [_vm._v(" " + _vm._s(_vm.$t('t1222_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: " "
  }, [_vm._v(_vm._s(_vm.autoModeExits))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "5px",
      "font-size": "8px",
      "line-height": "8px"
    },
    attrs: {
      "height": "5px"
    }
  }, [_c('td', {
    attrs: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-right": "1px solid rgba(116,116,116,0.34)"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "width": "18%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-right": "1px solid rgba(116,116,116,0.34)"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23308d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart1_print.vue
// module id = 1434
// module chunks = 7